var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emc-card-stats", {
    attrs: {
      color: "blue lighten-1",
      icon: "mdi-speedometer-medium",
      "icon-large": "",
      title: _vm.title,
      value: _vm.value,
      "show-actions": _vm.showActions,
      "text-actions": _vm.title,
      "sub-text": _vm.showActions ? null : "CH Média Docente",
    },
    scopedSlots: _vm._u([
      {
        key: "actions",
        fn: function () {
          return [
            _vm.showMoreButton
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { color: "primary", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "showMoreWorkLoadAvg"
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { btn: "" } }, [
                                    _vm._v("mdi-monitor-eye"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3093801949
                    ),
                  },
                  [_c("span", [_vm._v(" Ver Mais... ")])]
                )
              : _vm._e(),
            !_vm.hideRefresh
              ? _c("emc-button-icon", {
                  attrs: {
                    "btn-small": "",
                    disabled: _vm.isBusy,
                    icon: "mdi-refresh-circle",
                    text: _vm.updated_at || `Atualizar`,
                    color: "success",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.start()
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools",
        fn: function () {
          return [
            !_vm.hideRefresh
              ? _c("emc-chart-refresh-status", {
                  attrs: {
                    label: _vm.statusLabel,
                    failed: _vm.hasFailed,
                    "error-code": _vm.errorCode,
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }